import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
  Separator,
} from '@bechtel/gds';
import { t, Trans } from '@lingui/macro';
import { ReturnCaddyErrorProps } from './types';
import { ReturnCaddiesError, ReturnCaddyErrorCode } from '@bechtel/types';
import { map } from 'lodash';
import { ApolloError } from '@apollo/client';

const getErrorMessage = (error: ReturnCaddyErrorCode) => {
  switch (error) {
    case ReturnCaddyErrorCode.INVALID_CADDY_ID:
      return <Trans>Invalid Caddy ID.</Trans>;
    case ReturnCaddyErrorCode.INVALID_ROD_ROOM_ID:
      return <Trans>Invalid Rod Room ID</Trans>;
    case ReturnCaddyErrorCode.SERVICE_PROXY_ERROR:
      return <Trans>Service Proxy Error.</Trans>;
    case ReturnCaddyErrorCode.RETURN_CADDIES_MUTATION_ERROR:
      return <Trans>Return caddy action failed.</Trans>;
    case ReturnCaddyErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>You do not have permission to return rod caddy.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const BulkReturnCaddyError: FC<ReturnCaddyErrorProps> = ({ errors, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '450px', maxHeight: '450px' }}>
      <ModalHeader title={t`Return Caddy Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        {/* <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box> */}
        <Box pb={{ sm: '500' }} flexGrow={{ sm: 1 }} flexDirection={{ sm: 'column' }} css={{ minHeight: '150px' }}>
          {errors instanceof ApolloError && (
            <Box p={{ sm: '500' }}>
              <Text>
                <Trans>Network error has occured.Please close button and try again.</Trans>
              </Text>
            </Box>
          )}
          {errors instanceof Array &&
            map(errors, (error: ReturnCaddiesError) => (
              <Box key={error?.caddy?.id} flexDirection={{ sm: 'column' }}>
                <Box p={{ sm: '500' }}>
                  {error?.caddy?.caddy.label && <Text weight="600">{error?.caddy?.caddy.label} - </Text>}
                  <Box ml={{ sm: '200' }}>
                    <Text>{getErrorMessage(error.errorCode)}</Text>
                  </Box>
                </Box>
                <Separator spacing="000" color="grey.200" />
              </Box>
            ))}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
